import { MyMembershipPage } from './Membership.page';
import { MyCommissionDetailPage } from './MembershipCommissionDetail.page';

export const myMembershipRouter = {
  '/@/my_memberships': MyMembershipPage,
  '/@/my_memberships/commission_detail/:commissionRequestId': MyCommissionDetailPage,
};
